import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';

import AppContext from '../../AppContext';
import MoodleLoader from '../../components/MoodleLoader';

const ScheduleItemMoodleLoader = () => {
  const { userId, eventId } = useParams<{ userId: string; eventId: string }>();

  const { roleViewManager } = useContext(AppContext);

  return (
    <MoodleLoader
      endpoint={`/api/users/${userId}/schedule/moodle-redirect`}
      params={{
        eventId,
        requestContext: roleViewManager.getCurrentView(),
      }}
    />
  );
};

export default ScheduleItemMoodleLoader;
